import { PREVIEW_INVOICE } from "../Action/generateInvoice";

const initialState = {
  invoice: {
    buyer_company_name: "rahpoot industries",
    buyer_id: 4,
    cloth_quality: "147-99.5-56-88-500-pc",
    cloth_quality_id: 4,
    cloth_return_id: 33,
    company_id: 3,
    contract_id: 16,
    contract_no: "146",
    contract_type: "conversion",
    created_at: "2020-08-05T08:52:38.000000Z",
    hs_code: "yttw7",
    invoice_date: "2020-08-04",
    invoice_id: 24,
    invoice_no: "2345",
    invoice_note: "Desc",
    net_pass_quantity: 11000,
    rate_per_meter: "813.2726",
    tax_gst: "17",
    total_price_without_sale_tax: "34676.60",
    total_sale_tax_payable: "203980.00",
    total_value_include_sale_tax: "238656.60",
    updated_at: "2020-08-05T08:52:38.000000Z",
    variant_rate: [],
  },
};

function accountReducer(state = initialState, action) {
  switch (action.type) {
    case PREVIEW_INVOICE: {
      return { invoice: action.payload };
    }
    default:
      return state;
  }
}

export default accountReducer;
